<script>
  import Outro from './components/outro.svelte';

  import Footnotes from './components/footnotes.svelte';

  import Content from './components/content.svelte';
  import Header from './components/header.svelte';
  import Layout from './components/layout.svelte';
  import copy from './copy.yml';
  import Acknowledge from './components/Acknowledge.svelte';
  import Reference from './components/references.svelte';
</script>

<style>
</style>

<Header contents={copy.header} />
<Content contents={copy.contents} />
<Footnotes methodology={copy.methodology} />
<Reference references={copy.references} />
<Acknowledge contributors={copy.contributors} advisors={copy.advisors} />
